<template>
  <div class="item-container">
    <div class="item-img" v-if="(every.articleType === 5 && every.type === 0) || every.goodsTypeId === '4'">
      <div class="left" v-if="every.cover">
        <img v-lazy="$global.imgUrl + every.cover" alt="" />
      </div>
      <div class="right">
        <h2 class="title" @click="handleClick" v-html="every.title"></h2>
        <ul class="anther" v-if="every.authorList">
          <li v-for="(item, index) in every.authorList" :key="index">
            {{ item }}
          </li>
        </ul>
        <p class="createName">{{ every.createName }}</p>
        <div
          class="content"
          v-if="every.artSummary"
          v-html="every.artSummary"
        ></div>
        <div class="bottom">
          <ul class="icon">
            <li class="icon-item" @click.stop="clickFn('收藏')">
              <img
                v-if="every.isCollect"
                src="@/assets/img/details/1.png"
                alt=""
              />
              <img v-else src="@/assets/img/details/2.png" alt="" />
              <span>收藏</span>
            </li>
            <li class="share icon-item">
              <img src="@/assets/img/details/share.png" alt="" />
              <div>分享</div>
              <ul class="share_box">
                <div class="sanjiao"></div>
                <li @mouseover.stop="weChat" class="weChat">
                  <img src="@/assets/img/details/WeChat.png" alt="" />
                  <div>微信</div>
                  <div
                    :id="`WXqrcode${curcer}`"
                    :ref="`WXqrcode${curcer}`"
                    class="ma"
                  ></div>
                </li>
                <li @click.stop="weibo">
                  <img src="@/assets/img/details/weiBo.png" alt="" />
                  <div>新浪微博</div>
                </li>
                <li @mouseover.stop="qq" class="qq">
                  <img src="@/assets/img/details/QQ.png" alt="" />
                  <div>QQ</div>
                  <div
                    :id="`QQqrcode${curcer}`"
                    :ref="`QQqrcode${curcer}`"
                    class="ma"
                  ></div>
                </li>
                <li @click.stop="space">
                  <img src="@/assets/img/details/qqspace.png" alt="" />
                  <div>QQ空间</div>
                </li>
              </ul>
            </li>
          </ul>
          <div class="time">{{ every.createTime }}</div>
        </div>
      </div>
    </div>
    <div class="item-no-img" v-else>
      <h2 class="title" @click="handleClick" v-html="every.title"></h2>
      <div class="summary" v-if="every.summary">
        <p v-html="every.summary"></p>
        <div
          :class="{ active: every.status == 2 }"
          @click="clickFn('在线投稿', every)"
        >
          <img
            src="@/assets/img/qietu/fly.png"
            alt=""
            :active="every.status == 2"
          />在线投稿
        </div>
      </div>
      <div v-else class="anther">
        <span v-if="every.mettingName">{{ every.mettingName }} -&nbsp;</span>
        <span v-if="every.authorList">{{ every.authorList }} -&nbsp;</span>
        <span v-if="every.mettingTime">{{ every.mettingTime }}</span>
      </div>
      <ul class="icon" v-if="!every.summary">
        <li class="icon-item" @click.stop="clickFn('收藏')">
          <img v-if="every.isCollect" src="@/assets/img/details/1.png" alt="" />
          <img v-else src="@/assets/img/details/2.png" alt="" />
          <span>收藏</span>
        </li>
        <li style="padding: 0;display: flex;" v-if="every.articleType !== 2">
          <div
            class="icon-item"
            style="padding: 10px;"
            v-for="(item, index) in getIconList1"
            :key="index"
            @click.stop="clickFn(item)"
          >
            <img v-lazy="item.iconSrc" alt="" />
            <span>{{ item.iconTitle }}</span>
          </div>
        </li>
        <li class="share icon-item">
          <img src="@/assets/img/details/share.png" alt="" />
          <div>分享</div>
          <ul class="share_box">
            <div class="sanjiao"></div>
            <li @mouseover.stop="weChat" class="weChat">
              <img src="@/assets/img/details/WeChat.png" alt="" />
              <div>微信</div>
              <div
                :id="`WXqrcode${curcer}`"
                :ref="`WXqrcode${curcer}`"
                class="ma"
              ></div>
            </li>
            <li @click.stop="weibo">
              <img src="@/assets/img/details/weiBo.png" alt="" />
              <div>新浪微博</div>
            </li>
            <li @mouseover.stop="qq" class="qq">
              <img src="@/assets/img/details/QQ.png" alt="" />
              <div>QQ</div>
              <div
                :id="`QQqrcode${curcer}`"
                :ref="`QQqrcode${curcer}`"
                class="ma"
              ></div>
            </li>
            <li @click.stop="space">
              <img src="@/assets/img/details/qqspace.png" alt="" />
              <div>QQ空间</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  props: {
    every: {
      type: Object,
      required: true,
    },
    curcer: {
      type: String,
    },
  },
  created() {
    // this.qq();
    // this.weChat();
  },
  computed: {
    getIconList1() {
      let arr = this.iconList.slice();
      return arr.splice(0, 2);
    },
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      WXurl: "",
      QQurl: "",
      iconList: [
        {
          iconSrc: require("@/assets/img/qietu/down.png"),
          iconTitle: "下载",
        },
        {
          iconSrc: require("@/assets/img/qietu/write.png"),
          iconTitle: "在线阅读",
        },
        {
          iconSrc: require("@/assets/img/qietu/th.png"),
          iconTitle: "同行评议",
        },
        {
          iconSrc: require("@/assets/img/qietu/th.png"),
          iconTitle: "被引文献",
        },
      ],
    };
  },
  methods: {
    handleClick() {
      this.$emit("itemClick", this.every);
    },
    async read(type, id) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.readUrl +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    clickFn(item, every) {
      if (item === "收藏") {
        this.collect();
      } else if (item.iconTitle === "下载") {
        this.downPdf(this.every.articleType, this.every.articleId);
      } else if (item.iconTitle === "在线阅读") {
        this.read(this.every.articleType, this.every.articleId);
      } else if (item === "在线投稿" && every.status == 2) {
        window.open(
          `https://www.baikezaixian.com/details?ids=${every.perId}`,
          "_blank"
        );
      }
    },
    // 收藏
    async collect() {
      if(this.every.goodsTypeId === '4'){
        let res = await this.$apis.recomendServe.bookToCollect({
          bookId: this.every.id,
          goodsTypeId: this.every.goodsTypeId,
        });
        if (res.resultCode === "200") {
          if(this.every.isCollect === 1){
            this.every.isCollect = 0
          }else if(this.every.isCollect === 0){
            this.every.isCollect = 1
          }
        }
        return
      }
      
      if (!this.hasLogin) {
        this.$Message.error("请登录");
        return;
      }
      let obj = {
        action: this.every.isCollect ? 0 : 1,
        articleId: this.every.articleId,
        articleType: this.every.articleType,
      };
      await this.$apis.recomendServe.CollectItem(obj);
      await this.TFCollect();
    },
    async TFCollect() {
      let obj = {
        articleId: this.every.articleId,
        articleType: this.every.articleType,
      };
      let res = await this.$apis.recomendServe.isCollect(obj);
      this.every.isCollect = res.isCollect;
    },
    async downPdf(type, id) {
      console.log(this.hasLogin);
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.download +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new QRCode("QQqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      });
    },
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    qq() {
      if (this.QQurl !== "") return;
      this.QQurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    weibo() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pic=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
    space() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pics=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
    getUrl(isPC = false) {
      let url = "";
      if(this.every.goodsTypeId === '4'){
        url = this.$global.url1 + `detail/report?id=${this.every.id}`
      }
      if (this.every.articleType === 0) {
        // 论文
        url =
          this.$global.url1 +
          `${isPC ? "thesisDetail" : "thesisDetail"}?type=${
            this.every.articleType
          }&id=${this.every.articleId}`;
      } else if (this.every.articleType === 6) {
        // 报告
        url =
          this.$global.url1 +
          `${isPC ? "dataDetails" : "dataDetails"}?type=${
            this.every.articleType
          }&id=${this.every.articleId}`;
      } else if (this.every.articleType === 5) {
        // 资讯
        url =
          this.$global.url1 +
          `${isPC ? "msgDetails" : "msgDetails"}?type=${
            this.every.articleType
          }&id=${this.every.articleId}`;
      } else if (this.every.articleType == 2) {
        // 专著
        url =
          this.$global.url1 +
          `${isPC ? "concentrationDetails" : "concentrationDetails"}?type=${
            this.every.articleType
          }&id=${this.every.articleId}`;
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  box-sizing: border-box;
  margin-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid #e5e5e5;
  .title {
    font-size: 18px;
    vertical-align: middle;
    color: #263d78;
    cursor: pointer;
    .column {
      color: #0491ae;
    }
    &::v-deep p {
      display: inline-block !important;
    }
  }
  .summary {
    min-height: 120px;
    // margin: 30px 0;
    position: relative;
    p {
      margin-bottom: 40px;
      margin-top: 20px;
    }
    div {
      position: absolute;
      height: 30px;
      bottom: 10px;
      left: 0;
      padding: 5px;
      border: 1px solid;
      color: #ddd;

      &.active {
        width: 112px;
        height: 37px;
        line-height: 24px;
        text-align: center;
        border: 1px solid #dfe8f2;
        color: #515a6e;
        cursor: pointer;
        img {
          margin-right: 5px;
        }
      }
      img {
        vertical-align: middle;
      }
    }
  }

  .createName {
    margin: 5px 0;
    color: #666;
  }
  .anther {
    margin: 9px 0;
    font-size: 12px;
    color: #666666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    li {
      display: inline;
      margin-right: 10px;
    }
  }
  .bottom {
    margin-top: 20px;
  }
  .icon {
    display: flex;
    height: 37px;
    background: #ffffff;
    .icon-item {
    }
    .icon-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      min-width: 73px;
      height: 37px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
      border: 1px solid #dfe8f2;
      border-right: none;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
      span {
        margin-top: 3px;
      }
      &:last-child {
        border-right: 1px solid #eeeeee;
      }
    }
    .share:hover {
      .share_box {
        display: block;
      }
    }
    .share {
      position: relative;
      .share_box {
        cursor: pointer;
        display: none;
        right: -133px;
        top: -130px;
        position: absolute;
        width: 133px;
        height: 167px;
        background: #ffffff;
        box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
        border-radius: 10px;
        .weChat:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
          }
        }

        .weChat {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -10px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }
        .qq:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
          }
        }
        .qq {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -90px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
            z-index: 99;
          }
        }
        li {
          margin-top: 10px;
          margin-bottom: 0px;
          // padding: 10px;
          display: flex;
          flex-wrap: nowrap;
          //background: pink;
          justify-content: center;
          align-items: center;
          width: 133px;
          height: 30px;

          div {
            width: 60px;
            //background: yellow;
            margin-left: 10px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        .sanjiao {
          width: 0;
          height: 0;
          border-top: 3px solid transparent;
          border-right: 6px solid #fff;
          position: absolute;
          top: 50%;
          margin-top: -3px;
          left: -6px;
          border-bottom: 3px solid transparent;

          //background: pink;
        }
      }
    }
  }
  .time {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .content {
    width: 100%;
    // height: 60px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .item-img {
    position: relative;
    display: flex;
    width: 100%;
    .left {
      width: 150px;
      height: 150px;
      margin-right: 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      width: 857px;
      // min-height: 226px;
    }
  }
  .item-no-img {
    position: relative;
    width: 100%;
    height: 100%;
    .anther {
      margin: 30px 0px;
      span {
        margin: 0 10px;
      }
    }
  }
}
</style>
